import React from 'react'
import { HoverBorderGradient } from "../ui/hover-border-gradient";
import Link from 'next/link';
const HoverBtn = () => {
  return (
    <div className=" flex justify-center text-center">

      <Link href={'https://wa.link/ppbmjw'}>
    <HoverBorderGradient
      containerClassName="rounded-full"
      as="button"
      className="bg-black text-white flex items-center gap-2 px-6 py-3 font-semibold tracking-wide"
    >
      {/* <AceternityLogo /> */}
      <span>Get In Touch</span>
    </HoverBorderGradient>
      </Link>
    </div>
  )
}

export default HoverBtn